module.exports = __webpack_public_path__ + "static/media/pic15.4482c8ae.jpg";